import { IAnswerResponse } from "@/interfaces/api/responses/IAnswerResponse";
import { TaggedImage } from "./TaggedImage";

export class Answer {
    Id: number;
    selected?: boolean;
    Text?: string | null;
    TextMultiLang?: {
        [key: string]: string | null | undefined;
    }
    NextQuestion?: number | null;
    NextQuiz?: number | null;
    Picture?: string | null;
    TaggedPictures?: TaggedImage[];
    Score?: number | null;
    Value: string | number | null;

    QuestionIdsToDrop?: number[];

    constructor(answer: Answer) {
        this.Id = answer.Id;
        this.Text = answer.Text ?? undefined;
        this.TextMultiLang = answer.TextMultiLang ?? undefined;
        this.NextQuestion = answer.NextQuestion ?? undefined;
        this.NextQuiz = answer.NextQuiz ?? undefined;
        this.Picture = answer.Picture ?? undefined;
        this.TaggedPictures = answer.TaggedPictures ?? undefined;
        this.Score = answer.Score ?? undefined;
        this.Value = answer.Value;
        this.QuestionIdsToDrop = answer.QuestionIdsToDrop ?? undefined;
    }


    static createFromApiResponse(response: IAnswerResponse): Answer {
        const newAnswer = new Answer({
            Id: response.id,
            Text: response.text,
            TextMultiLang: {},
            NextQuestion: response.nextQuestion,
            NextQuiz: response.nextQuiz,
            Picture: response.asset,
            TaggedPictures: response.tagged_assets ? response.tagged_assets.map((tagged_asset) => TaggedImage.createFromApiResponse(tagged_asset)) : undefined,
            Score: response.score,
            Value: response.value,
            QuestionIdsToDrop: response.questionIdToDrop ?? undefined
        });

        Object.keys(response).forEach(key => {

            if (key.includes("text")) {
                newAnswer[key] = response[key];
            }
            if(key.includes("explanation")) {
                newAnswer[key] = response[key];
            }

        });
    

        return newAnswer;
    }
}